import {useUserContext} from '@hconnect/login'
import {useUpmPlantContext} from '@hconnect/upm'
import {usePermissionsParsedQuery} from '@hproduce/permissions'
import {useMemo} from 'react'

import {usePlantConfigQuery} from '../hooks/api/dataScience'
import {getPageAvailability} from '../permissions'

export const usePageAvailability = (plantCode?: string) => {
  const {data: plantConfig} = usePlantConfigQuery(plantCode)
  const {loggedUser} = useUserContext()
  const {data: permissions} = usePermissionsParsedQuery()
  const {country: countryId} = useUpmPlantContext()

  return useMemo(() => {
    if (!plantConfig || !loggedUser || !plantCode || !permissions) {
      return null
    }
    const availableFeatures = plantConfig.available_features
    return getPageAvailability(availableFeatures, permissions, countryId, plantCode)
  }, [loggedUser, plantConfig, permissions, countryId, plantCode])
}
